export const Name = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_15426)">
      <path
        d="M10.8499 12.6499H13.1499L11.9999 8.99994L10.8499 12.6499ZM19.9999 8.68994V3.99994H15.3099L11.9999 0.689941L8.68994 3.99994H3.99994V8.68994L0.689941 11.9999L3.99994 15.3099V19.9999H8.68994L11.9999 23.3099L15.3099 19.9999H19.9999V15.3099L23.3099 11.9999L19.9999 8.68994ZM14.2999 15.9999L13.5999 13.9999H10.3999L9.69994 15.9999H7.79994L10.9999 6.99994H12.9999L16.1999 15.9999H14.2999Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_15426">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
